/* BeMe cart: one-tap subscription conversion while preserving Shopify's cart APIs. */
(() => {
  if (window.BemeCartLoaded) return;
  window.BemeCartLoaded = true;

  /* Klaviyo injects two promotional H1s after page load. Preserve their
     visual treatment while keeping the storefront page title as the only H1. */
  const normalizeKlaviyoPopupHeadings = () => {
    document.querySelectorAll('.klaviyo-form-richtext h1').forEach((heading) => {
      const replacement = document.createElement('h2');
      Array.from(heading.attributes).forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.innerHTML = heading.innerHTML;
      replacement.style.margin = '0';
      replacement.style.padding = '0';
      replacement.setAttribute('data-beme-klaviyo-heading', 'true');
      heading.replaceWith(replacement);
    });
  };

  let klaviyoHeadingSyncQueued = false;
  const queueKlaviyoHeadingSync = () => {
    if (klaviyoHeadingSyncQueued) return;
    klaviyoHeadingSyncQueued = true;
    window.requestAnimationFrame(() => {
      normalizeKlaviyoPopupHeadings();
      klaviyoHeadingSyncQueued = false;
    });
  };

  normalizeKlaviyoPopupHeadings();
  new MutationObserver(queueKlaviyoHeadingSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  class BemeCartNudge extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.beme-cart-nudge__btn');
      if (button) button.addEventListener('click', () => this.switchAll(button));
    }

    async switchAll(button) {
      const pairs = (this.getAttribute('data-switch') || '')
        .split(',')
        .map((pair) => pair.split(':').map((value) => parseInt(value, 10)))
        .filter((pair) => pair.length === 2 && pair.every(Number.isFinite))
        .sort((a, b) => b[0] - a[0]);
      if (!pairs.length) return;

      const previousLabel = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Switching…';

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        for (const [line, sellingPlan] of pairs) {
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, selling_plan: sellingPlan }),
          });
          if (!response.ok) throw new Error(`Unable to update cart line ${line}`);
        }

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Try again';
        return;
      }

      button.removeAttribute('aria-busy');
      button.textContent = previousLabel;
    }
  }

  if (!customElements.get('beme-cart-nudge')) customElements.define('beme-cart-nudge', BemeCartNudge);
})();
